import { render, staticRenderFns } from "./ArtificialDialog.vue?vue&type=template&id=f743cfb0&"
import script from "./ArtificialDialog.vue?vue&type=script&lang=js&"
export * from "./ArtificialDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArtificialDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports